export default __webpack_public_path__ + "static/media/processing.a9b56e17.svg";